import { effect, EnvironmentProviders, inject, provideEnvironmentInitializer } from '@angular/core';
import { AuthService } from '@app/core/auth/auth.service';
import { WebsocketService } from '@app/core/websocket/websocket.service';
import { ProfileAction } from '@app/layout/common/profile/state/profile.action';
import { filter, switchMap, take, tap } from 'rxjs';

export const provideInitializeWebsocket = (): EnvironmentProviders => {
  return provideEnvironmentInitializer(() => {
    const wsSvc = inject(WebsocketService);
    const auth = inject(AuthService);
    const profileAction = inject(ProfileAction);

    effect(() => {
      wsSvc.getWebSocket(auth.accessTokenSignal());
    });

    wsSvc.connection
      .pipe(
        filter((event) => event.type === 'connection' && event.data === 'open'),
        take(1),
        switchMap(() => profileAction.actions.getSuccess$),
        tap(() => wsSvc.wsJoinReminderChannel())
      )
      .subscribe();
  });
};
